import { normalizeContractStats } from './live-price-feed';

// Restrict rollout here without changing individual chart consumers.
// Supported scopes: 'all', 'market', 'story', 'static'.
export const CHARTS_LIVE_UPDATES_SCOPE = 'all';
export const LIVE_CHART_PERIODS = Object.freeze(['24h', '7d', '30d', '90d']);

const CLOSED_MARKET_STATUSES = ['Closed', 'Settled', 'Expired', 'Suspended', 'Maintenance'];

export function isLiveChartEligible({
  enabled,
  placement,
  chartType,
  timeline,
  market,
  scope = CHARTS_LIVE_UPDATES_SCOPE,
}) {
  return (
    enabled === true &&
    ['market', 'story', 'static'].includes(placement) &&
    (scope === 'all' || scope === placement) &&
    chartType === 'line' &&
    LIVE_CHART_PERIODS.includes(timeline) &&
    !!market &&
    market.isOpen !== false &&
    !CLOSED_MARKET_STATUSES.includes(market.status)
  );
}

export function getEligibleContractIds({ market, contractIds }) {
  const contracts = market?.contracts || market?.marketContracts || [];
  const closedIds = new Set(
    contracts
      .filter((contract) => contract.isOpen === false || contract.contractIsOpen === false)
      .map((contract) => Number(contract.contractId)),
  );
  return [
    ...new Set(
      contractIds
        .filter((id) => typeof id === 'number' || typeof id === 'string')
        .map(Number)
        .filter((id) => Number.isSafeInteger(id) && id > 0 && !closedIds.has(id)),
    ),
  ];
}

// The market's last trade prices, in cents, read the same way as the live feed's.
export function getLiveSeedPrices({ market, contractIds }) {
  const contracts = market?.contracts || market?.marketContracts || [];
  const prices = {};
  for (const contractId of contractIds) {
    const contract = contracts.find((c) => Number(c.contractId) === contractId);
    const tick = normalizeContractStats(contractId, { LastTradePrice: contract?.lastTradePrice });
    if (tick) prices[contractId] = tick.priceCents;
  }
  return prices;
}
